import React, { useEffect, useState } from 'react';

import classes from "../SitesOnSchedule/sitesOnScheduleSearchBar.module.css"
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ListBox } from 'primereact/listbox';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import DataManager from '../../hooks/DataManager';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

const ActiveSitesSearchbar = (props) => {
  const { 
        placeholder, 
        onChange, 
        value, 
        handleFocus, 
        handleBlur, 
        showFilterButton, 
        groups, 
        online, 
        setOnline, 
        offline, 
        setOffline, 
        deviceTag, 
        setDeviceTag, 
        deviceType, 
        setDeviceType, 
        groupName, 
        setGroupName,
        submit, 
        setSubmit,
        noTag, 
        setNoTag,
        isControllers
    } = props;
  
  
  const [showFilters, setShowFilters] = useState(false);

  const [localOnline, setLocalOnline] = useState(online);
  const [localOffline, setLocalOffline] = useState(offline);
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localDeviceType, setLocalDeviceType] = useState(deviceType);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localNoTag, setLocalNoTag] = useState(noTag);
  const [localIncludes, setLocalIncludes] = useState("")
  const [localExcludes, setLocalExcludes] = useState("")

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
          event.preventDefault();
      }
  };

  const handleClear = () => {
      onChange({ target: { value: '' } }); 
  };

  const handleShowFilters = () => {
    setShowFilters(prev => !prev);
  };

  const HandleResetFilters = () => {
    setOnline(0)
    setOffline(0)
    setDeviceTag(null)
    isControllers ? setDeviceType(1) : setDeviceType(0)
    setGroupName(null)
    setNoTag(0)

    setLocalOnline(0)
    setLocalOffline(0)
    setLocalDeviceTag(null)
    isControllers ? setLocalDeviceType(1) : setLocalDeviceType(0)
    setLocalGroupName(null)
    setLocalNoTag(0)

    setSubmit(submit+1)
    setShowFilters(false)
  }

  const HandleApplyFilters = () => {
    setOnline(localOnline)
    setOffline(localOffline)
    setDeviceTag(localDeviceTag)
    setDeviceType(localDeviceType)
    setGroupName(localGroupName)
    setNoTag(localNoTag)

    setShowFilters(false)
    setSubmit(submit+1)
  }


  const handleInputChange = (e) => {
    setLocalDeviceTag(e.target.value);
    console.log('Current input:', e.target.value); // For debugging
  };

  const handleSetIncludes = () => {
    setLocalIncludes(true)
  }

  const handleSetExcludes = () => {
    setLocalIncludes(false)
  }

  const handleStatusChange = (status) => {
    if (status == "ONLINE"){
        setLocalOnline(localOnline == 1 ? 0 : 1)
    }

    if (status == "OFFLINE") {
        setLocalOffline(localOffline == 1 ? 0 : 1)
    }

    if (status == "ALL"){
        setLocalOnline(1)
        setLocalOffline(1)
    }
  }

  const handleNoPortalName = () => {
    setLocalNoTag(localNoTag == 0 ? 1 : 0 )
  }


  return (
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              { showFilterButton && <button className={classes.filterButton} onClick={handleShowFilters} type="button">
                  <img style={{ height: '30px', width: '30px' }} src={filters}/>
              </button>}
          </div>

          {showFilters && (
                <div className={classes.filterDropdown}>
                  
                    <div className={classes.filterRow}>
                    <div className="flex flex-wrap justify-content-center gap-3">
                    <div className="flex align-items-center">
                            <Checkbox  name="Online" value="localOnline" onChange={() => handleStatusChange("ALL")} checked={((localOnline == 0 && localOffline == 0) || (localOffline == 1 && localOnline == 1))} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">All</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="Online" value="localOnline" onChange={() => handleStatusChange("ONLINE")} checked={localOnline == 1} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Online</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="offline" value="localOffline" onChange={() => handleStatusChange("OFFLINE")} checked={localOffline == 1} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">Offline</label>
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className={classes.filterRow2}>
                        <label className={classes.filterLabel}>Group:</label>
                        <MultiSelect
                            value={localGroupName}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalGroupName(e.value)}
                            options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                            placeholder="Choose group"
                            filter                 
                            filterPlaceholder="Search groups..."
                        />
                    </div>

                    { !isControllers && <div className={classes.filterRow}>
                    <div className="flex flex-wrap justify-content-center gap-3">
                    <div className="flex align-items-center">
                            <Checkbox  name="all" value="localDeviceType" onChange={() => setLocalDeviceType(0)} checked={localDeviceType == 0} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">All</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="physical" value="localDeviceType" onChange={() => setLocalDeviceType(1)} checked={localDeviceType == 1} />
                            <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Physical controllers</label>
                        </div>
                        <br></br>
                        <div className="flex align-items-center">
                            <Checkbox  name="cloud" value="localDeviceType" onChange={() => setLocalDeviceType(2)} checked={localDeviceType == 2} />
                            <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">Cloud controllers</label>
                        </div>
                      </div>
                    </div>}
                    <br></br>
                    <div className="flex align-items-center">
                          <Checkbox  name="localDeviceTag" value="setLocalDeviceTag" onChange={() => handleNoPortalName()} checked={localNoTag == 1} />
                          <label style={{marginLeft:"8px"}} htmlFor="excludes" className="ml-2">No portal name</label>
                    </div>
                    <div className={classes.filterType2} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <label htmlFor="word" className="font-bold block mb-2">
                        Portal site name includes the word:
                      </label>                    
                      <InputText id="word" keyfilter="alphanum" value={deviceTag} onChange={handleInputChange}/>

                    </div>

                    <div className={classes.buttonRow}>
                      <Button  type="button" style={{marginRight:"15px"}} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger'/>
                      <Button  type="button" label="Apply" onClick={HandleApplyFilters}/>
                    </div>
                </div>
            )}
      </div>
  );
};

export default ActiveSitesSearchbar;